import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import GlobalContext from '../_contexts/GlobalContext';
import { fitContentToBounds, Label, Stack, Toggle } from '@fluentui/react';
import { GetSetCardCount } from '../services/DBConnect';
import styles from '../styles/pokemon.module.scss';
import { TSet } from '../constants/types';

export interface ISetInfoComponent {
  toggleAvailable: Function;
  sets: TSet[];
  selectedSetID: number;
}

const SetInfoComponent : React.FunctionComponent<ISetInfoComponent> = (props: ISetInfoComponent) => {
  const { Strings, showAvailableOnly } = useContext(GlobalContext);
  const set = props.sets.filter(s => s.id === props.selectedSetID)[0];

  if (set) {
  return(
    <Stack horizontal horizontalAlign='center' className={styles.SetInfoComponent} verticalAlign='center'>
        <Label>
          <span className={`${styles.availableContainer} ${!set.cardcount ? styles.availableContainer0Available : set.cardcount > 99 ? styles.availableContainer100plus : styles.availableContainer100Min}`}>
            {set.cardcount ? set.cardcount : 0} kaarten beschikbaar in {set.name}
          </span>
        </Label>
        <Toggle style={{marginLeft:5}} label={Strings.SoldoutToggle} checked={!showAvailableOnly} inlineLabel onChange={() => { props.toggleAvailable(); }} />
    </Stack>
    );
  } else {
    return (<></>);
  }
  
}

export default SetInfoComponent;
